export var deprecatedTabsTheme = {
  baseStyle: _ref => {
    var {
      variant
    } = _ref;
    return {
      container: {
        display: 'flex',
        flexDirection: 'column'
      },
      tab: {
        color: 'neutral.darker',
        cursor: 'pointer',
        textStyle: 'body2Semi',
        borderBottom: 'input-thick.transparent',
        transition: '0.1s ease-in-out',
        transitionProperty: 'border, color',
        '&:first-of-type': {
          marginLeft: variant === 'section' ? 'xl' : 'none'
        },
        _hover: {
          color: 'neutral.black',
          borderBottom: 'input-thick.transparent'
        },
        _selected: {
          color: 'neutral.black',
          borderBottom: 'input-thick.focused'
        }
      }
    };
  }
};
//# sourceMappingURL=DeprecatedTabs.theme.js.map